// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
//== Font classes to mixin
@font-size-saturn:  14px;
@font-size-neptune: 12px;
@font-size-venus:   11px;
@font-size-mars:    13px;
@font-size-jackdaw: 11px;
@font-size-magpie:  18px;
@font-size-crow:    24px;
@font-size-special: 16px;

.flow-special-one {
  font: @font-size-special 'Gotham Bold';
  color: @flow-app-dark-grey;
}

.flow-jupiter-one {
  font: @font-size-jupiter 'Gotham Light';
  color: @flow-app-dark-grey;
}

.flow-jupiter-invert {
  font: @font-size-jupiter 'Gotham Light';
  color: @flow-app-white;
}

.flow-saturn-one {
  font: @font-size-saturn 'Gotham Book';
  color: @flow-app-dark-grey;
}

.flow-saturn-two {
  font: @font-size-saturn 'Gotham Bold';
  color: @flow-app-dark-grey;
}

.flow-saturn-three {
  font: @font-size-saturn 'Gotham Book';
  color: @flow-app-icon;
}

.flow-saturn-medium {
  font: @font-size-saturn 'Gotham Medium';
  color: @flow-app-dark-grey;
}

.flow-saturn-invert {
  font: @font-size-saturn 'Gotham Book';
  color: @flow-app-white;
}

.flow-saturn-light {
  font: @font-size-saturn 'Gotham Light';
  color: @flow-app-light-grey;
}

.flow-neptune-one {
  font: @font-size-neptune 'Gotham Light'; // 0.875 = @font-size-neptune
  color: @flow-app-light-grey;
}

.flow-neptune-two {
    font: @font-size-neptune 'Gotham Book';
    color: @flow-app-dark-grey;
}

.flow-neptune-three {
  font: @font-size-neptune 'Gotham Book';
  color: @flow-app-mid-grey;
}

.flow-neptune-bold {
    font: @font-size-neptune 'Gotham Bold';
    color: @flow-app-dark-grey;
}

.flow-neptune-medium {
  font: @font-size-neptune 'Gotham Medium';
  color: @flow-app-dark-grey;
}

.flow-neptune-medium-special {
  font: @font-size-neptune 'Gotham Medium';
  color: @flow-app-dark-grey;
  letter-spacing: 1px;
}

.flow-neptune-invert {
  font: @font-size-neptune 'Gotham Medium';
  color: @flow-app-white;
}

.flow-venus-one {
  font: @font-size-venus 'Gotham Book';
  color: @flow-app-dark-grey;
}

.flow-venus-two {
  font: @font-size-venus 'Gotham Book';
  color: @flow-app-mid-grey;
}

.flow-venus-two-special {
  font: @font-size-venus 'Gotham Light';
  color: @flow-app-light-grey;
  letter-spacing: 1px;
}

.flow-venus-three {
  font: @font-size-venus 'Gotham Book';
  color: @flow-app-light-grey;
}

// Only used for old video service remove when we the new video solution takes over.
.flow-venus-special {
  font: @font-size-venus 'Gotham Book';
  color: @flow-app-red;
}

.flow-venus-invert {
  font: @font-size-venus 'Gotham Book';
  color: @flow-app-white;
}

.flow-venus-invert-60 {
  font: @font-size-venus 'Gotham Book';
  color: @flow-app-white;
  opacity: 0.6;
}

.flow-mars-one {
  font: @font-size-mars 'Gotham Book';
  color: @flow-app-mid-grey;
}

.flow-mars-two {
  font: @font-size-mars 'Gotham Book';
  color: @flow-app-dark-grey;
}

.jackdaw {
  font: @font-size-jackdaw 'Gotham Medium';
  color: @flow-app-dark-grey;
}

.magpie {
  font: @font-size-magpie 'Gotham Medium';
  color: @flow-app-dark-grey;
}

.crow {
  font: @font-size-crow 'Gotham Medium';
  color: @flow-app-dark-grey;
}
*/
.flow-title-special {
  font: 16px 'Roboto-Bold';
  color: #242424;
}
.flow-special-font {
  font: 32px 'Roboto-Light';
  color: #727272;
}
.flow-profile-bold {
  font: 12px 'Roboto-Bold';
  color: #242424;
}
.flow-profile-regular {
  font: 12px 'Roboto-Regular';
  color: #242424;
}
.flow-top-bar-title {
  font: 14px 'Roboto-Bold';
  color: #242424;
}
.flow-list-item-title {
  font: 14px 'Roboto-Regular';
  color: #242424;
}
.flow-list-item-title-alt {
  font: 14px 'Roboto-Bold';
  color: #242424;
}
.flow-list-item-second {
  font: 12px 'Roboto-Regular';
  color: #727272;
}
.flow-list-item-second-dark {
  font: 12px 'Roboto-Regular';
  color: #242424;
}
.flow-list-item-second-alt {
  font: 12px 'Roboto-Medium';
  color: #3f4142;
}
.flow-list-item-third {
  font: 12px 'Roboto-Regular';
  color: #3f4142;
}
.flow-list-item-third-alt {
  font: 12px 'Roboto-Bold';
  color: #3f4142;
}
.flow-section-title {
  font: 12px 'Roboto-Bold';
  color: #242424;
}
.flow-suggestion-item-title {
  font: 12px 'Roboto-Bold';
  color: #242424;
}
.flow-time {
  font: 12px 'Roboto-Regular';
  color: #727272;
}
.flow-settings-item {
  font: 14px 'Roboto-Regular';
  color: #242424;
}
.flow-settings-item-second {
  font: 12px 'Roboto-Medium';
  color: #727272;
}
.flow-settings-text {
  font: 12px 'Roboto-Regular';
  color: #727272;
}
.flow-settings-item-header {
  font: 12px 'Roboto-Regular';
  color: #727272;
}
.flow-headline {
  font: 24px 'Roboto-Bold';
  color: #242424;
}
.flow-headline-two {
  font: 14px 'Roboto-Regular';
  color: #727272;
}
.flow-headline-three {
  font: 18px 'Roboto-Regular';
  color: #242424;
}
.open-graph-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  max-height: 34px;
  overflow: hidden;
  font: 14px 'Roboto-Bold';
  color: #ffffff;
}
.open-graph-description {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  max-height: 32px;
  overflow: hidden;
  font: 12px 'Roboto-Regular';
  color: #d7d7d7;
}
.open-graph-site-name {
  font: 10px 'Roboto-Regular';
  color: #adadad;
}
.callmodal-caller {
  font: 14px 'Roboto-Regular';
  color: #ffffff;
}
.callmodal-info {
  font: 12px 'Roboto-Regular';
  color: #adadad;
}
.callmodal-state {
  font: 12px 'Roboto-Bold';
  color: #ffffff;
}
.flow-italic-one {
  font: 12px 'Roboto-Regular';
  color: #adadad;
  font-style: italic;
}
.flow-italic-two {
  font: 12px 'Roboto-Bold';
  color: #adadad;
  font-style: italic;
}
/* Scrollbars styling in WebKit */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
/* this targets the default scrollbar (compulsory) */
/* the new scrollbar will have a flat appearance with the set background color */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
}
/* this will style the thumb, ignoring the track */
/* optionally, you can style the top and the bottom buttons (left and right for horizontal bars) */
/* if both the vertical and the horizontal bars appear, then perhaps the right bottom corner also needs to be styled */
.scroll {
  overflow-y: auto;
  overflow-y: overlay;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
.scroll:hover::-webkit-scrollbar-thumb {
  display: initial;
}
body {
  font: 12px 'Roboto-Light';
  color: #adadad;
  margin: 0;
  padding: 0;
}
input[type='search'] {
  -webkit-appearance: textfield;
}
#content {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
b {
  font-family: 'Roboto-Bold';
}
`, "",{"version":3,"sources":["webpack://./src/app/css/main.less","webpack://./style_modules/less-components/styles/fonts.less","webpack://./src/app/css/scrollbars.less"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA0JC;ACeD;EACE,wBAAA;EACA,cAAA;ADbF;ACgBA;EACE,yBAAA;EACA,cAAA;ADdF;ACiBA;EACE,wBAAA;EACA,cAAA;ADfF;ACkBA;EACE,2BAAA;EACA,cAAA;ADhBF;ACmBA;EACE,wBAAA;EACA,cAAA;ADjBF;ACoBA;EACE,2BAAA;EACA,cAAA;ADlBF;ACqBA;EACE,wBAAA;EACA,cAAA;ADnBF;ACsBA;EACE,2BAAA;EACA,cAAA;ADpBF;ACuBA;EACE,2BAAA;EACA,cAAA;ADrBF;ACwBA;EACE,0BAAA;EACA,cAAA;ADtBF;ACyBA;EACE,2BAAA;EACA,cAAA;ADvBF;AC0BA;EACE,wBAAA;EACA,cAAA;ADxBF;AC2BA;EACE,wBAAA;EACA,cAAA;ADzBF;AC4BA;EACE,wBAAA;EACA,cAAA;AD1BF;AC6BA;EACE,2BAAA;EACA,cAAA;AD3BF;AC8BA;EACE,2BAAA;EACA,cAAA;AD5BF;AC+BA;EACE,0BAAA;EACA,cAAA;AD7BF;ACgCA;EACE,2BAAA;EACA,cAAA;AD9BF;ACiCA;EACE,2BAAA;EACA,cAAA;AD/BF;ACkCA;EACE,wBAAA;EACA,cAAA;ADhCF;ACmCA;EACE,2BAAA;EACA,cAAA;ADjCF;ACoCA;EACE,2BAAA;EACA,cAAA;ADlCF;ACqCA;EACE,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;ADnCF;ACsCA;EACE,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,cAAA;ADpCF;ACuCA;EACE,2BAAA;EACA,cAAA;ADrCF;ACwCA;EACE,2BAAA;EACA,cAAA;ADtCF;ACyCA;EACE,2BAAA;EACA,cAAA;ADvCF;AC0CA;EACE,wBAAA;EACA,cAAA;ADxCF;AC2CA;EACE,2BAAA;EACA,cAAA;EACA,kBAAA;ADzCF;AC4CA;EACE,wBAAA;EACA,cAAA;EACA,kBAAA;AD1CF;AACA,iCAAiC;AE/RjC;EACI,UAAA;EACA,WAAA;AFiSJ;AACA,oDAAoD;AACpD,gFAAgF;AE7RhF;EACI,kBAAA;EACA,0BAAA;EACA,uBAAA;AF+RJ;AACA,kDAAkD;AAClD,kGAAkG;AAClG,sHAAsH;AEzRtH;EACI,gBAAA;EACA,mBAAA;EAEA,4CAAA;AF0RJ;AEvRA;EACI,gBAAA;AFyRJ;AApTA;EACI,yBAAA;EACA,cAAA;EAEA,SAAA;EACA,UAAA;AAqTJ;AAlTA;EACI,6BAAA;AAoTJ;AAjTA;EACI,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAmTJ;AA/SA;EACI,0BAAA;AAiTJ","sourcesContent":["@import '~less-components/styles/components.less';\n@import 'scrollbars.less';\n\nbody {\n    font: @font-size-medium 'Roboto-Light';\n    color: @flow-app-light-grey;\n\n    margin: 0;\n    padding: 0;\n}\n\ninput[type='search'] {\n    -webkit-appearance: textfield; // Adjustment for Safari\n}\n\n#content {\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    // background-color: @flow-app-super-light-grey;\n}\n\nb {\n    font-family: 'Roboto-Bold';\n}\n","@import '~less-components/styles/flow-colors.less';\n\n//== Font faces to use\n\n/*\n//== Font classes to mixin\n@font-size-saturn:  14px;\n@font-size-neptune: 12px;\n@font-size-venus:   11px;\n@font-size-mars:    13px;\n@font-size-jackdaw: 11px;\n@font-size-magpie:  18px;\n@font-size-crow:    24px;\n@font-size-special: 16px;\n\n.flow-special-one {\n  font: @font-size-special 'Gotham Bold';\n  color: @flow-app-dark-grey;\n}\n\n.flow-jupiter-one {\n  font: @font-size-jupiter 'Gotham Light';\n  color: @flow-app-dark-grey;\n}\n\n.flow-jupiter-invert {\n  font: @font-size-jupiter 'Gotham Light';\n  color: @flow-app-white;\n}\n\n.flow-saturn-one {\n  font: @font-size-saturn 'Gotham Book';\n  color: @flow-app-dark-grey;\n}\n\n.flow-saturn-two {\n  font: @font-size-saturn 'Gotham Bold';\n  color: @flow-app-dark-grey;\n}\n\n.flow-saturn-three {\n  font: @font-size-saturn 'Gotham Book';\n  color: @flow-app-icon;\n}\n\n.flow-saturn-medium {\n  font: @font-size-saturn 'Gotham Medium';\n  color: @flow-app-dark-grey;\n}\n\n.flow-saturn-invert {\n  font: @font-size-saturn 'Gotham Book';\n  color: @flow-app-white;\n}\n\n.flow-saturn-light {\n  font: @font-size-saturn 'Gotham Light';\n  color: @flow-app-light-grey;\n}\n\n.flow-neptune-one {\n  font: @font-size-neptune 'Gotham Light'; // 0.875 = @font-size-neptune\n  color: @flow-app-light-grey;\n}\n\n.flow-neptune-two {\n    font: @font-size-neptune 'Gotham Book';\n    color: @flow-app-dark-grey;\n}\n\n.flow-neptune-three {\n  font: @font-size-neptune 'Gotham Book';\n  color: @flow-app-mid-grey;\n}\n\n.flow-neptune-bold {\n    font: @font-size-neptune 'Gotham Bold';\n    color: @flow-app-dark-grey;\n}\n\n.flow-neptune-medium {\n  font: @font-size-neptune 'Gotham Medium';\n  color: @flow-app-dark-grey;\n}\n\n.flow-neptune-medium-special {\n  font: @font-size-neptune 'Gotham Medium';\n  color: @flow-app-dark-grey;\n  letter-spacing: 1px;\n}\n\n.flow-neptune-invert {\n  font: @font-size-neptune 'Gotham Medium';\n  color: @flow-app-white;\n}\n\n.flow-venus-one {\n  font: @font-size-venus 'Gotham Book';\n  color: @flow-app-dark-grey;\n}\n\n.flow-venus-two {\n  font: @font-size-venus 'Gotham Book';\n  color: @flow-app-mid-grey;\n}\n\n.flow-venus-two-special {\n  font: @font-size-venus 'Gotham Light';\n  color: @flow-app-light-grey;\n  letter-spacing: 1px;\n}\n\n.flow-venus-three {\n  font: @font-size-venus 'Gotham Book';\n  color: @flow-app-light-grey;\n}\n\n// Only used for old video service remove when we the new video solution takes over.\n.flow-venus-special {\n  font: @font-size-venus 'Gotham Book';\n  color: @flow-app-red;\n}\n\n.flow-venus-invert {\n  font: @font-size-venus 'Gotham Book';\n  color: @flow-app-white;\n}\n\n.flow-venus-invert-60 {\n  font: @font-size-venus 'Gotham Book';\n  color: @flow-app-white;\n  opacity: 0.6;\n}\n\n.flow-mars-one {\n  font: @font-size-mars 'Gotham Book';\n  color: @flow-app-mid-grey;\n}\n\n.flow-mars-two {\n  font: @font-size-mars 'Gotham Book';\n  color: @flow-app-dark-grey;\n}\n\n.jackdaw {\n  font: @font-size-jackdaw 'Gotham Medium';\n  color: @flow-app-dark-grey;\n}\n\n.magpie {\n  font: @font-size-magpie 'Gotham Medium';\n  color: @flow-app-dark-grey;\n}\n\n.crow {\n  font: @font-size-crow 'Gotham Medium';\n  color: @flow-app-dark-grey;\n}\n*/\n\n//== Font classes to mixin\n@font-size-small: 12px;\n@font-size-medium: 12px;\n@font-size-large: 14px;\n@font-size-title-special: 16px;\n@font-size-midlarge: 18px;\n@font-size-xlarge: 24px;\n@font-size-special: 32px;\n\n.flow-title-special {\n  font: @font-size-title-special 'Roboto-Bold';\n  color: @flow-app-dark-grey;\n}\n\n.flow-special-font {\n  font: @font-size-special 'Roboto-Light';\n  color: @flow-app-mid-grey;\n}\n\n.flow-profile-bold {\n  font: @font-size-small 'Roboto-Bold';\n  color: @flow-app-dark-grey;\n}\n\n.flow-profile-regular {\n  font: @font-size-small 'Roboto-Regular';\n  color: @flow-app-dark-grey;\n}\n\n.flow-top-bar-title {\n  font: @font-size-large 'Roboto-Bold';\n  color: @flow-app-dark-grey;\n}\n\n.flow-list-item-title {\n  font: @font-size-large 'Roboto-Regular';\n  color: @flow-app-dark-grey;\n}\n\n.flow-list-item-title-alt {\n  font: @font-size-large 'Roboto-Bold';\n  color: @flow-app-dark-grey;\n}\n\n.flow-list-item-second {\n  font: @font-size-medium 'Roboto-Regular';\n  color: @flow-app-mid-grey;\n}\n\n.flow-list-item-second-dark {\n  font: @font-size-medium 'Roboto-Regular';\n  color: @flow-app-dark-grey;\n}\n\n.flow-list-item-second-alt {\n  font: @font-size-medium 'Roboto-Medium';\n  color: @flow-app-dark-icon;\n}\n\n.flow-list-item-third {\n  font: @font-size-small 'Roboto-Regular';\n  color: @flow-app-dark-icon;\n}\n\n.flow-list-item-third-alt {\n  font: @font-size-small 'Roboto-Bold';\n  color: @flow-app-dark-icon;\n}\n\n.flow-section-title {\n  font: @font-size-small 'Roboto-Bold';\n  color: @flow-app-dark-grey;\n}\n\n.flow-suggestion-item-title {\n  font: @font-size-medium 'Roboto-Bold';\n  color: @flow-app-dark-grey;\n}\n\n.flow-time {\n  font: @font-size-small 'Roboto-Regular';\n  color: @flow-app-mid-grey;\n}\n\n.flow-settings-item {\n  font: @font-size-large 'Roboto-Regular';\n  color: @flow-app-dark-grey;\n}\n\n.flow-settings-item-second {\n  font: @font-size-medium 'Roboto-Medium';\n  color: @flow-app-mid-grey;\n}\n\n.flow-settings-text {\n  font: @font-size-medium 'Roboto-Regular';\n  color: @flow-app-mid-grey;\n}\n\n.flow-settings-item-header {\n  font: @font-size-small 'Roboto-Regular';\n  color: @flow-app-mid-grey;\n}\n\n.flow-headline {\n  font: @font-size-xlarge 'Roboto-Bold';\n  color: @flow-app-dark-grey;\n}\n\n.flow-headline-two {\n  font: @font-size-large 'Roboto-Regular';\n  color: @flow-app-mid-grey;\n}\n\n.flow-headline-three {\n  font: @font-size-midlarge 'Roboto-Regular';\n  color: @flow-app-dark-grey;\n}\n\n.open-graph-title {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  text-overflow: ellipsis;\n  max-height: 34px;\n  overflow: hidden;\n  font: @font-size-large 'Roboto-Bold';\n  color: @flow-app-white;\n}\n\n.open-graph-description {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  text-overflow: ellipsis;\n  max-height: 32px;\n  overflow: hidden;\n  font: @font-size-medium 'Roboto-Regular';\n  color: @flow-app-ornament;\n}\n\n.open-graph-site-name {\n  font: 10px 'Roboto-Regular';\n  color: @flow-app-light-grey;\n}\n\n.callmodal-caller {\n  font: @font-size-large 'Roboto-Regular';\n  color: @flow-app-white;\n}\n\n.callmodal-info {\n  font: @font-size-medium 'Roboto-Regular';\n  color: @flow-app-light-grey;\n}\n\n.callmodal-state {\n  font: @font-size-medium 'Roboto-Bold';\n  color: @flow-app-white;\n}\n\n.flow-italic-one {\n  font: @font-size-medium 'Roboto-Regular';\n  color: @flow-app-light-grey;\n  font-style: italic;\n}\n\n.flow-italic-two {\n  font: @font-size-medium 'Roboto-Bold';\n  color: @flow-app-light-grey;\n  font-style: italic;\n}\n","/* Scrollbars styling in WebKit */\n\n::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n} /* this targets the default scrollbar (compulsory) */\n\n::-webkit-scrollbar-track {\n} /* the new scrollbar will have a flat appearance with the set background color */\n\n::-webkit-scrollbar-thumb {\n    border-radius: 4px;\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n} /* this will style the thumb, ignoring the track */\n\n::-webkit-scrollbar-button {\n} /* optionally, you can style the top and the bottom buttons (left and right for horizontal bars) */\n\n::-webkit-scrollbar-corner {\n} /* if both the vertical and the horizontal bars appear, then perhaps the right bottom corner also needs to be styled */\n\n.scroll {\n    overflow-y: auto; //Since overflow: overlay only works in WebKit renderers make fallback on auto\n    overflow-y: overlay;\n    //overflow-x: hidden; This breaks the lazily loaded Avatars. Disable this until we know what's wrong.\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n\n.scroll:hover::-webkit-scrollbar-thumb {\n    display: initial;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
